import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BackendPagination } from "../models/pagination.model";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { TaskQueryOptions } from "../models/endpoints/tasks.model";

/**
 * `options` is additive and optional — existing callers are unaffected. It
 * exists so a surface can state its own freshness policy without forking the
 * query: the Home worklist (KAN-2553) refetches on every page entry and never
 * on a timer.
 */
export const useTasks = (pagination: BackendPagination, options?: TaskQueryOptions) => {
	const queryClient = useQueryClient();
	const queryKey = ["participants-tasks", pagination];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getTasks({
				config: { params: pagination },
			});
			return response;
		},
		...options,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
